module.exports = __webpack_public_path__ + "img/computer2@2x.20db063f.png";